import React, { useEffect } from 'react';

function Showcase() {
  useEffect(()=>{
    document.title = 'John Chen | Showcase'
  }, [])

  return <>
  <h3>This page is still in development.</h3>
  <p>To see my old online resume site and my projects, visit
    <a href='https://seevee.co.nz/john#projects' target="_blank" rel="noreferrer"> https://seevee.co.nz/john#projects</a>
    .
  </p>
</>;
}

export default Showcase;
